module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"btnGo":"Go Swiset","titleAwesome":"Awesome! Let\u0027s go Swiset..."},"es":{"btnGo":"Ir a Swiset","titleAwesome":"Genial! Ya puedes ir a Swiset..."}}')
  delete Component.options._Ctor
}
